import React from 'react'
import { colors, space } from '@entur/tokens'
import { Heading5 } from '@entur/typography'
import { SmallAlertBox } from '@entur/alert'
import { SecondarySquareButton } from '@entur/button'
import { CheckIcon, CloseIcon } from '@entur/icons'
import { BlueModal } from '../modal/blue-modal'

type ChangeValuesBlueModalProps = {
  title: string
  setOpen: (isOpen: boolean) => void
  isOpen: boolean
  isLoading: boolean
  onSubmit: () => void
  children: React.ReactNode
  errorMessage?: string
  onClose?: () => void
}
export const ChangeTicketRightModal: React.FC<ChangeValuesBlueModalProps> = ({
  title,
  setOpen,
  isOpen,
  isLoading,
  onSubmit,
  children,
  errorMessage,
  onClose,
}) => {
  return (
    <BlueModal setOpen={setOpen} open={isOpen}>
      <Heading5 style={{ marginTop: 0, marginBottom: space.small }}>{title}</Heading5>
      <form
        className="new-ticket-right-card"
        data-cy="new-ticket-right-card"
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit()
        }}
      >
        <section style={{ marginBottom: space.small }}>{children}</section>
        {errorMessage && (
          <section style={{ marginBottom: space.small }}>
            <SmallAlertBox variant="error">{errorMessage}</SmallAlertBox>
          </section>
        )}
        <section>
          <SecondarySquareButton
            type="button"
            onClick={() => {
              onClose?.()
              setOpen(false)
            }}
            style={{ float: 'right' }}
          >
            <CloseIcon color={colors.validation.lavaContrast} />
          </SecondarySquareButton>
          <SecondarySquareButton
            type="submit"
            loading={isLoading}
            style={{ float: 'right', marginRight: space.extraSmall2 }}
          >
            <CheckIcon color={colors.validation.mintContrast} />
          </SecondarySquareButton>
        </section>
      </form>
    </BlueModal>
  )
}
